class TicketDigits extends React.Component {
  constructor(props) {
    super(props);
    this.loopDigits = this.loopDigits.bind(this);
    this.lotteryCount = this.props.lottery;
  }
  loopDigits(data) {
    let lotteryArray = [];
    for (let index = 1; index <= data; index++) {
      lotteryArray.push(index);
    }
    return lotteryArray;
  }
  randomNumberSelect() {}

  render() {
    return (
      <>
        {this.loopDigits(49).map((digit, index) => (
          <div
            className="card__text lottery"
            key={index}
            onClick={this.props.getDataKey}
            id={`cardText-${index}`}
            title={digit}
          >
            <span id={`span-${index}`}> {digit}</span>
          </div>
        ))}
      </>
    );
  }
}

export default TicketDigits;
